import ShopMiniBasketResourceModel from '../../generated/types/model/resource/ShopMiniBasketResourceModel';

export default class ShopMiniBasketResourceViewModel extends ShopMiniBasketResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
